import {
  array,
  type InferOutput,
  maxLength,
  minLength,
  nullable,
  number,
  object,
  optional,
  pipe,
  string,
  transform
} from 'valibot'

import { VALIDATION_MESSAGES } from '@/constants/common/validation.constants'

import {
  siteDisplayNameMiddleRule,
  siteDisplayNameShortRule
} from './site-display-name-rules'

export const CreateSiteDtoSchema = object({
  name: pipe(string(), minLength(1, VALIDATION_MESSAGES.REQUIRED_ITEM)), // 地点名
  code: pipe(string(), minLength(1, VALIDATION_MESSAGES.REQUIRED_ITEM)), // 地点コード
  location: string(), // 住所
  note: string(), // 備考
  postalCode: optional(string(), ''), // 郵便番号
  prefecture: optional(string(), ''), // 都道府県
  city: optional(string(), ''), // 市区町村
  blockNumber: optional(string(), ''), // 丁名・番地
  buildingName: optional(string(), ''), // 建物名
  contactName: optional(
    pipe(string(), maxLength(30, VALIDATION_MESSAGES.MAX_LENGTH(30))),
    ''
  ), // 担当者名
  phoneNumber: optional(
    pipe(string(), maxLength(20, VALIDATION_MESSAGES.MAX_LENGTH(20))),
    ''
  ), // 連絡先電話番号
  displayNameShort: optional(siteDisplayNameShortRule), // 短表示名称
  displayNameMiddle: optional(siteDisplayNameMiddleRule), // 中表示名称
  searchAreaIds: array(number()), // 検索エリアID
  contractAreaId: nullable(number()), // 契約エリアID
  siteGroupCode: optional(
    nullable(
      pipe(
        string(),
        maxLength(50, VALIDATION_MESSAGES.MAX_LENGTH(50)),
        transform((v) => (v === '' ? null : v))
      )
    )
  ) // 関連荷主紐付けコード（空文字は null として送信）
})

export type CreateSiteDto = InferOutput<typeof CreateSiteDtoSchema>
